module.exports = __webpack_public_path__ + "img/baiyingzi1.a66c9124.png";